import { checkRolePreference } from "utils/accountPreference";
import { checkIsUCHClinicUser } from "./currentUser.util";
import { CLINIC_ROLES, USER_ROLES } from "static/constants";
import { filterNonUCHAccounts } from "./account.util";

// Whether an admin has assigned this user hospitals. From the profile — local storage
// goes stale between logins.
export const checkHasAssignedHospitals = (user) =>
  user?.isFollowingHospital === true &&
  (user?.followingHospitals || []).some((hospital) =>
    String(hospital ?? "").trim()
  );

// Only a physician's reports are restricted by hospital.
export const checkIsHospitalRestrictedUser = (user, userRole) =>
  userRole === USER_ROLES.PHYSICIAN && checkHasAssignedHospitals(user);

// Whether the Hospital column belongs to this user. Drives both its default visibility
// and whether Column settings lists it, so the two cannot drift apart.
export const checkHasHospitalColumnAccess = (user, userRole) =>
  checkIsUCHClinicUser(user?.accounts) ||
  checkIsHospitalRestrictedUser(user, userRole);

export const transmissionTableColumnVisibility = (accounts, userRole, user) => {
  const filteredAccounts = filterNonUCHAccounts(user?.accounts);

  return {
    returned: CLINIC_ROLES.includes(userRole) ?? false,
    clinic_billed: CLINIC_ROLES.includes(userRole) ?? false,
    alert_flag: false,
    reportNotes: true,
    account: filteredAccounts.length > 1 || false,
    oru: checkRolePreference(accounts, "transmission_table", "oru", userRole),
    eSig: checkRolePreference(accounts, "transmission_table", "eSig", userRole),
    signedBy: checkRolePreference(
      accounts,
      "transmission_table",
      "signedBy",
      userRole
    ),
    signedAt: checkRolePreference(
      accounts,
      "transmission_table",
      "signedAt",
      userRole
    ),
    hospital: checkHasHospitalColumnAccess(user, userRole) || false,
  };
};

export const clearAllTransmissionTableSortingKeys = () => {
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith("transmissionTableSorting:")) {
      localStorage.removeItem(key);
    }
  });
};
